import * as z from "zod";

import { ReferrerSummarySchema } from "../shared/referrer";

export const verifyMagicLink = {
  name: "verifyMagicLink" as const,
  input: z.object({ token: z.string().min(1).max(4096) }),
  output: z.object({
    referrer: ReferrerSummarySchema,
    authToken: z.string().min(1),
  }),
};
